var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9139",
    "data-name": "Group 9139",
    transform: "translate(0 -0.214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1649",
    "data-name": "Ellipse 1649",
    cx: 53,
    cy: 52.5,
    rx: 53,
    ry: 52.5,
    transform: "translate(0 0.214)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(21.566 21.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_010---Idea",
    "data-name": "010---Idea",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.554,40.468a7.526,7.526,0,0,0,1.1.633c.456.233,1.22.624,1.274.9A1.833,1.833,0,0,1,4.8,43.067c-.157.338-.322.628-.464.878-.386.683-1.033,1.827-.058,2.624.228.211.622.516.981.792a2.659,2.659,0,0,0-.343,1.523,1.52,1.52,0,0,0,.626,1.038c.234.166.484.309.731.45.624.356.868.521.95.852a2.908,2.908,0,0,1-.106,1.267c-.062.282-.122.565-.158.844a6.282,6.282,0,0,0,.347,2.844,3.954,3.954,0,0,0,3.733,2.876,4.243,4.243,0,0,0,.866-.092A80.089,80.089,0,0,0,20.8,56.3c2.378,1.4,3.88,5.639,4.272,7.231a1.056,1.056,0,0,0,1.025.8l26.494-.074a1.056,1.056,0,0,0,1-1.372,8.148,8.148,0,0,0-1.069-2.006,9.857,9.857,0,0,1-.683-1.142,19.943,19.943,0,0,1-1.192-3,35.615,35.615,0,0,1-1.239-6.175,1.056,1.056,0,1,0-2.094.258,37.647,37.647,0,0,0,1.316,6.544,22.12,22.12,0,0,0,1.31,3.3,11.708,11.708,0,0,0,.818,1.38l.071.106L26.9,62.221a16.816,16.816,0,0,0-3.715-6.741l.95-.332c.707-.247,1.24-.433,1.514-.52,4.522-1.43,6.783-3.49,6.722-6.122a1.028,1.028,0,0,0-1.075-1.03,1.056,1.056,0,0,0-1.03,1.08c.025,1.086-.864,2.67-5.252,4.059-.286.092-.837.284-1.569.539-.784.274-1.782.623-2.882,1h-.007a82.138,82.138,0,0,1-9.078,2.744A1.868,1.868,0,0,1,9.3,55.487,4.2,4.2,0,0,1,9.056,53.6c.027-.222.078-.441.127-.662a4.624,4.624,0,0,0,.092-2.247,3.508,3.508,0,0,0-1.954-2.158l-.22-.126a3.957,3.957,0,0,1,.406-.652,1.056,1.056,0,0,0-.2-1.5c-.253-.186-.851-.633-1.288-.986.051-.092.106-.193.158-.285.166-.29.355-.628.539-1.019A3.957,3.957,0,0,0,7,41.6c-.253-1.288-1.486-1.919-2.387-2.379a6,6,0,0,1-.868-.5,4.482,4.482,0,0,1-.633-.515c0-.159.171-.546.975-1.526a42.459,42.459,0,0,0,4.831-7.847,3.118,3.118,0,0,0,.408-1.428,3.694,3.694,0,0,0-1.542-2.639c-.427-.392-.83-.761-.876-1.1a1.918,1.918,0,0,1,.165-.725c.172-.453.37-.9.57-1.341a15.42,15.42,0,0,0,1.032-2.783l.106-.45a26.388,26.388,0,0,1,.863-3.116A18.1,18.1,0,0,1,13.43,9.063c2.019-2.136,5.2-3.648,9.462-4.5a68.61,68.61,0,0,1,9.9-1.427,22.512,22.512,0,0,1,4.968.282,1.056,1.056,0,0,0,.361-2.079,24.515,24.515,0,0,0-5.439-.31A70.451,70.451,0,0,0,22.475,2.5c-4.759.95-8.218,2.619-10.58,5.114a20.224,20.224,0,0,0-4.234,6.906,28.63,28.63,0,0,0-.935,3.37l-.106.445a13.774,13.774,0,0,1-.9,2.4c-.211.481-.431.963-.62,1.461a3.535,3.535,0,0,0-.28,1.766,4.03,4.03,0,0,0,1.539,2.357c.516.474.855.807.859,1.1a1.752,1.752,0,0,1-.18.459,40.723,40.723,0,0,1-4.623,7.512c-.763.93-1.562,2.014-1.392,3.1A3.223,3.223,0,0,0,2.554,40.468Z",
    transform: "translate(-0.998 -0.997)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M12.277,19.454l.106-.47a23.513,23.513,0,0,1,.7-2.595,13.908,13.908,0,0,1,2.9-4.75,11.051,11.051,0,0,1,4.865-2.672,1.056,1.056,0,1,0-.614-2.019,13.072,13.072,0,0,0-5.785,3.242,16.024,16.024,0,0,0-3.339,5.471,25.159,25.159,0,0,0-.782,2.859l-.106.457a1.056,1.056,0,0,0,.788,1.267,1.038,1.038,0,0,0,.24.027A1.056,1.056,0,0,0,12.277,19.454Z",
    transform: "translate(-0.487 -0.669)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.732,
    cy: 1.732,
    r: 1.732,
    transform: "translate(8.756 22.606)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M28,21.944a14.467,14.467,0,0,0,3.567,9.806,18.142,18.142,0,0,0,2.428,2.111c1.544,1.194,3.007,2.335,3.4,3.922a3.167,3.167,0,0,0-2,2.939v2.111A3.167,3.167,0,0,0,37.5,45.805V46a4.222,4.222,0,0,0,8.444,0v-.194a3.167,3.167,0,0,0,2.111-2.972V40.722a3.167,3.167,0,0,0-2.005-2.939c.387-1.583,1.851-2.729,3.4-3.922a18.208,18.208,0,0,0,2.428-2.111,14.474,14.474,0,0,0,3.571-9.806A14,14,0,0,0,41.722,8,14,14,0,0,0,28,21.944Zm10.555,1.889H37.5a1.056,1.056,0,1,1,1.056-1.056Zm4.222,13.722H40.667V25.944h2.111ZM41.722,48.11A2.111,2.111,0,0,1,39.611,46h4.222A2.111,2.111,0,0,1,41.722,48.11Zm4.222-5.278a1.056,1.056,0,0,1-1.056,1.056H38.555A1.056,1.056,0,0,1,37.5,42.833V40.722a1.056,1.056,0,0,1,1.056-1.056h6.333a1.056,1.056,0,0,1,1.056,1.056Zm7.389-20.856a12.342,12.342,0,0,1-3.022,8.359,16.5,16.5,0,0,1-2.15,1.855,14.777,14.777,0,0,0-3.272,3.123V25.944h1.056a3.167,3.167,0,1,0-3.167-3.167v1.056H40.667V22.777A3.167,3.167,0,1,0,37.5,25.944h1.056v9.369a14.758,14.758,0,0,0-3.267-3.122,16.523,16.523,0,0,1-2.151-1.856,12.336,12.336,0,0,1-3.026-8.359c.106-6.432,5.417-11.865,11.611-11.865S53.233,15.544,53.333,21.976Zm-8.444,1.857V22.777a1.056,1.056,0,1,1,1.056,1.056Z",
    transform: "translate(0.501 -0.608)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M57.056,22.111h3.167a1.056,1.056,0,0,0,0-2.111H57.056a1.056,1.056,0,0,0,0,2.111Z",
    transform: "translate(2.056 0.059)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M52.369,10.917a1.056,1.056,0,0,0,.747-.309l2.239-2.24a1.056,1.056,0,1,0-1.493-1.493l-2.24,2.239a1.056,1.056,0,0,0,.746,1.8Z",
    transform: "translate(1.796 -0.688)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M41.056,6.278a1.056,1.056,0,0,0,1.056-1.056V2.056a1.056,1.056,0,1,0-2.111,0V5.222A1.056,1.056,0,0,0,41.056,6.278Z",
    transform: "translate(1.168 -0.997)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M30.607,10.607a1.056,1.056,0,0,0,0-1.494l-2.24-2.239a1.056,1.056,0,1,0-1.493,1.493l2.239,2.24a1.056,1.056,0,0,0,1.494,0Z",
    transform: "translate(0.421 -0.688)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M22.056,20a1.056,1.056,0,1,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
    transform: "translate(0.113 0.059)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobExperience);
export default __webpack_public_path__ + "static/media/JobExperience.ddb514c4ba1d1f2d9d02907985de503d.svg";
export { ForwardRef as ReactComponent };